<template>
  <div class="chat-window" :class="{ '-minimize': mini }">
    <div class="chat-window-content">
      <div class="chat-window__head">
        <div class="chat-window__head__icon"></div>
        <div class="chat-window__head__title">{{ agentName }}</div>
        <div class="chat-window__head__buttons">
          <div
            class="chat-window__head__buttons__minimize"
            @click="minimize()"
          ></div>
          <div class="chat-window__head__buttons__end" @click="closeChat()">
            Sonlandır
          </div>
        </div>
      </div>
      <div class="chat-window__content">
        <transition-group name="fade" mode="out-in">
          <div
            class="chat-bubble"
            v-for="(item, index) in form.messages"
            :key="`message-${index}`"
            :class="`-${item.type}`"
          >
            <div class="chat-bubble__text">{{ item.text }}</div>
          </div>
        </transition-group>
        <div class="chat-bubble -service" v-if="agentTyping">
          <div class="chat-bubble__text">Müşteri temsilcisi yazıyor...</div>
        </div>
      </div>
      <div class="chat-window__editor" :title="editorTitle">
        <input
          v-model.trim="message"
          type="text"
          name="chat"
          placeholder="Mesajınızı yazınız..."
          :disabled="!isOnline"
          @keyup.enter="sendMessage"
        />
        <div
          class="chat-window__editor__send"
          :class="{ '-disabled': !isOnline || !isTyping }"
          @click="sendMessage"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    step: {
      type: Number,
      default: 1,
    },
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      mini: false,
      isOnline: false,
      message: "",
      isTyping: false,
      agentTyping: false,
      cometd: null,
      chatChannel: "/service/chatV2/customer-support",
      gmsCometURL:
        "https://onlinechat.katilimemeklilik.com.tr:8443/genesys/cometd",
      banktype: this.$store.getters.getBankType,
    };
  },
  computed: {
    editorTitle: function () {
      return this.isOnline
        ? ""
        : "Bir müşteri temsilcisinin bağlanmasını bekleyin.";
    },
    agentName: function () {
      if (!this.form.data.agent) return "Müşteri Temsilcisi";

      let name = this.form.data.agent.split(" ");
      name.shift();
      let _name = name[0];

      return _name;
    },
  },
  watch: {
    message: function (val) {
      if (!val) return this.changeTyping(false);
      if (!this.isTyping) this.changeTyping(true);
    },
  },
  created() {
    this.chechChatStatus();
  },
  methods: {
    chechChatStatus: function () {
      let vm = this;

      if (!vm.form.data.secureKey) return vm.startChat();

      vm.resumeChat();
    },
    startChat: function () {
      console.log("startChat >>");
      let vm = this;

      let type =
        vm.banktype === "corporate"
          ? "Kurumsal İnternet Şube"
          : "Bireysel İnternet Şube";
      // let type = "MobilTest";

      vm.cometd = new org.cometd.CometD();
      console.log("vm.cometd >>", vm.cometd);

      vm.cometd.addListener(vm.chatChannel, vm.handleChatEvent);
      vm.cometd.configure({
        url: vm.gmsCometURL,
      });

      vm.cometd.handshake(function (handshakeReply) {
        if (handshakeReply.successful) {
          let data = {
            operation: "requestChat",
            nickname: vm.form.data.name,
            subject: "Savings Account",
            userData: {
              name: vm.form.data.name,
              mail: vm.form.data.mail,
              phone: vm.form.data.phone,
              chatType: type,
            },
          };

          console.log("data >>", data);
          vm.$store.dispatch("setChatStatus", "open");
          vm.$store.dispatch("setChatNickname", vm.form.data.name);
          vm.$store.dispatch("setChatMail", vm.form.data.mail);
          vm.$store.dispatch("setChatPhone", vm.form.data.phone);
          vm.$store.dispatch("setChatMessages", vm.form.messages);

          vm.cometd.publish(vm.chatChannel, data);
        }
      });
    },
    resumeChat: function () {
      let vm = this;
      console.log("resumeChat >>", vm.form.data.secureKey);

      vm.isOnline = true;

      vm.cometd = new org.cometd.CometD();

      vm.cometd.configure({
        url: vm.gmsCometURL,
        secureKey: vm.form.data.secureKey,
      });

      vm.cometd.handshake();
    },
    handleChatEvent: function (response) {
      console.log("handleChatEvent response >>", response);
      let vm = this;

      if (response.data.messages.length == 0) return;

      vm.$store.dispatch("setChatSecureKey", response.data.secureKey);
      vm.form.data.secureKey = response.data.secureKey;

      let message = response.data.messages[0];

      if (message.from.type == "Client" && message.type == "ParticipantJoined")
        return;

      // Görüşme bittiyse
      if (message.type == "ParticipantLeft") return vm.closeChat();

      // Müşteri temsilcisi bağlandıysa
      if (message.from.type == "Agent" && message.type == "ParticipantJoined") {
        vm.form.data.agent = message.from.nickname;
        vm.$store.dispatch("setChatAgent", message.from.nickname);

        vm.form.messages.push({
          type: "service",
          text: `Merhaba, ben ${vm.agentName}. Size nasıl yardımcı olabilirim?`,
        });

        vm.isOnline = true;

        return;
      }

      // Müşteri temsilcisi yazıyorsa
      if (message.from.type == "Agent" && message.type == "TypingStarted") {
        console.log("Müşteri temsilcisi yazıyor");

        vm.agentTyping = true;
        return;
      }

      // Müşteri temsilcisi yazmayı durduysa
      if (message.from.type == "Agent" && message.type == "TypingStopped") {
        console.log("Müşteri temsilcisi yazmayı bıraktı");
        vm.agentTyping = false;

        return;
      }

      if (message.from.type == "Agent") vm.agentTyping = false;

      if (message.type == "TypingStarted" || message.type == "TypingStopped")
        return;

      vm.form.messages.push({
        type: message.from.type == "Agent" ? "service" : "customer",
        text: message.text,
      });

      var container = this.$el.querySelector(".chat-window__content");

      // let deneme = document.getElementsByClassName("chat-window__content");

      setTimeout(() => {
        container.scrollTop = container.scrollHeight;
      }, 150);
    },
    sendMessage: function () {
      let vm = this;

      if (!vm.message) return;

      console.log("secureKey >>", vm.form.data.secureKey);

      let data = {
        operation: "sendMessage",
        message: vm.message,
        secureKey: vm.form.data.secureKey,
      };

      vm.cometd.publish(vm.chatChannel, data);

      return (vm.message = "");
    },
    changeTyping: function (status) {
      let vm = this;

      vm.isTyping = status;

      let data = {
        operation: status ? "startTyping" : "stopTyping",
        secureKey: vm.form.data.secureKey,
      };

      vm.cometd.publish(vm.chatChannel, data);
    },
    closeChat: function () {
      let vm = this;

      if (!vm.cometd) return;

      let data = {
        operation: "disconnect",
        secureKey: vm.form.data.secureKey,
      };

      console.log("data >>", data);

      vm.cometd.publish(vm.chatChannel, data);
      vm.cometd.disconnect();
      vm.cometd = null;

      vm.$store.dispatch("deletechat").then(() => vm.$emit("changeStep", 1));
    },
    minimize: function () {
      this.mini = !this.mini;
    },
  },
};
</script>